import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2 sf-pro"
}
const _hoisted_2 = { class: "whitespace-pre-line" }
const _hoisted_3 = { class: "flex flex-col gap-3" }
const _hoisted_4 = { class: "text-xl font-bold pt-4 mb-2" }
const _hoisted_5 = { class: "whitespace-pre-line" }
const _hoisted_6 = { class: "text-base font-semibold pt-2 mb-1" }
const _hoisted_7 = { class: "whitespace-pre-line" }

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { inject, ref, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthMapAccordion',
  props: /*@__PURE__*/_mergeModels({
    matrix: {},
    hasPremiumAccess: { type: Boolean }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const isOpen = _useModel<boolean>(__props, "modelValue");
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(DestinyMatrixKeysEnum.HEALTH_MAP);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, {
    type: "white",
    onOpened: getData,
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    isBlocked: !__props.hasPremiumAccess
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.health-map")), 1)
    ]),
    "faq-content": _withCtx(() => [
      (description.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(description.value["desc"]), 1),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(description.value['chakras'], (chakra, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(chakra["name"]), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(chakra["desc"]), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chakra['arcana'], (arcana, arcanaKey) => {
                    return (_openBlock(), _createElementBlock("div", { key: arcanaKey }, [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(arcana["title"]), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(arcana["value"]), 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.collapse")), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "isBlocked"]))
}
}

})